import React from "react";
import TextBlock from "../components/DynamicZoneComponents/TextBlock";
import MediaGallery from "../components/DynamicZoneComponents/MediaGallery";
import DocumentBlock from "./DynamicZoneComponents/DocumentBlock";

const DynamicZoneBuilder = ({ components }) => {
  return (
    <>
      {components.map((comp, idx) => {
        switch (comp.__component) {
          case "bloky.text":
            return <TextBlock key={idx} {...comp} />;
          case "bloky.images":
            return <MediaGallery key={idx} {...comp} />;
          case "bloky.files":
            return <DocumentBlock key={idx} {...comp} />;
          default:
            return null;
        }
      })}
    </>
  );
};

export default DynamicZoneBuilder;
